
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
export default defineComponent({
  components: {
    DoubleRightOutlined
  },
  props: {
    menu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props) {
    const route = useRoute()
    const breadcrumbdata: any = ref([])
    const routs = router.options.routes
    const menulist = props.menu
    function gettitle(key: string, arr: any) {
      let str = ''
      arr.forEach((item: any) => {
        if (item.key === key) {
          str = item.title
        }
        if (str === '' && (item.children || []).length) {
          str = gettitle(key, item.children)
        }
      })
      return str
    }
    // 通过当前路由name获取路径
    watch(
      () => route.name,
      (val: any) => {
        const key = (route.fullPath.split('?')[0].split('/page/')[1] || '').split('/')
        breadcrumbdata.value = []
        key.forEach((item: any) => {
          const title = gettitle(item, props.menu)
          breadcrumbdata.value.push({
            key: item,
            title: title
          })
        })
      },
      { deep: true }
    )
    return {
      breadcrumbdata,
      menulist
    }
  }
})
